(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('ConfirmationItemController', ConfirmationItemController);

    function ConfirmationItemController($scope, $sce, $uiRouterGlobals) {
        'ngInject';
        var vm = this;

        vm.$onInit = function() {
            vm.voucherItem.voucher.voucherDescriptionTrustedHtml = $sce.trustAsHtml(vm.voucherItem.voucher.voucherDescription);
            vm.walletDebug = $uiRouterGlobals.params.walletDebug || false;
            if (vm.walletDebug) {
                vm.voucherItem.displayAppleWalletButton = true;
                vm.voucherItem.displayGoogleWalletButton = true;
            }
            vm.deliveryEmail = vm.voucherItem.voucherPurchaser.email;
            vm.customerEmail = vm.voucherItem.voucherPurchaser.customerEmail;

            vm.signetProperties  = ["HSAVUK", "ERNVUK"];
            vm.isSignetProperty = vm.signetProperties.includes(vm.voucherItem.hotel.hotelCode.toUpperCase());

            vm.hideSavvyProperties = vm.signetProperties;
            vm.hideSavvy = vm.hideSavvyProperties.includes(vm.voucherItem.hotel.hotelCode.toUpperCase()) && vm.deliveryEmail != vm.customerEmail;
        }


    }

})();
